import { DeviceIdentification } from '../components/AddServiceCase/components/IdentifyDevice/IdentifyDevice.types';
import { MN_SN_CONCATENATED_PATTERN, QR_URL_PATTERN } from './constants';

export const formatMaterialNumber = (digits: string): string => {
  const d = digits.slice(0, 8);
  if (d.length <= 1) return d;
  if (d.length <= 4) return `${d[0]}.${d.slice(1)}`;
  if (d.length <= 7) return `${d[0]}.${d.slice(1, 4)}-${d.slice(4)}`;
  return `${d[0]}.${d.slice(1, 4)}-${d.slice(4, 7)}.${d[7]}`;
};

export const parseBarcode = (decodedText: string): DeviceIdentification | null => {
  // AC: QR code URL with 8-digit MN and 6-digit SN, e.g., https://kaer.ch/er/s/18888880/061101
  // AC: QR code URL with MN only, e.g., .../18888880/ → serialNumber: ''
  let match = decodedText.match(QR_URL_PATTERN);
  if (match) {
    const [_, mn, sn] = match;
    return {
      materialNumber: formatMaterialNumber(mn),
      serialNumber: sn ?? '',
    };
  }

  // AC: 14-digit barcode — first 8 digits = MN, remaining 6 = SN, e.g., 17834614010130
  match = decodedText.match(MN_SN_CONCATENATED_PATTERN);
  if (match) {
    const [_, mn, sn] = match;
    return {
      materialNumber: formatMaterialNumber(mn),
      serialNumber: sn,
    };
  }

  return null;
};
